import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.344 12.813A5.156 5.156 0 1 0 7.43 9.229l-4.726 4.726a.7.7 0 0 0-.205.498v2.344c0 .39.313.703.703.703h2.344c.39 0 .703-.314.703-.703v-1.172h1.172c.39 0 .703-.313.703-.703V13.75h1.172a.7.7 0 0 0 .498-.205l.976-.976a5.2 5.2 0 0 0 1.573.243m1.172-5.157a1.172 1.172 0 1 1-.001-2.343 1.172 1.172 0 0 1 0 2.343"
    }, null, -1)
  ]))]))
}
export default { render: render }